module.exports = __webpack_public_path__ + "img/share1.16b908e7.png";